<template>
  <div>
    <a
      class="text-blue-700 block"
      href="javascript:void(0)"
      ref="btnDropdownRef"
      v-on:click="toggleDropdown($event)"
    >
      <div class="items-center flex">
        <span
          class=" text-white inline-flex items-center justify-center rounded-full"
        >
          Hi, {{ getName }} <i class="fa fa-caret-down ml-2 text-sm"></i>
        </span>
      </div>
    </a>
    <div
      ref="popoverDropdownRef"
      class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg w-48"
      v-bind:class="{
        hidden: !dropdownPopoverShow,
        block: dropdownPopoverShow,
      }"
    >
      <a
        href="javascript:void(0);"
        v-on:click="toggleDD($event,'profile')"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blue-700"
      >
        Profile
      </a>
      <a
        href="javascript:void(0);"
        v-if="!isSuperAdmin"
        v-on:click="toggleDD($event,'change-password-user')"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blue-700"
      >
        Change Password
      </a>
      <div class="h-0 my-2 border border-solid border-blueGray-100" />
      <a
        href="javascript:void(0);"
        @click="logout"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blue-700"
      >
        Log Out
      </a>
    </div>
  </div>
</template>

<script>
import { createPopper } from '@popperjs/core';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      dropdownPopoverShow: false,
    };
  },
  computed: {
    ...mapGetters('AuthModule', ['accessToken', 'isArtist', 'isSuperAdmin', 'isOps',
      'isRecruitment', 'isReviewer', 'isFinance', 'tokenType', 'isAdmin',
      'getName', 'isUpdateTnc', 'getUser']),
  },
  methods: {
    ...mapActions('AuthModule', ['removeAuthentication']),
    toggleDropdown(event) {
      event.preventDefault();
      if (this.dropdownPopoverShow) {
        this.dropdownPopoverShow = false;
      } else {
        this.dropdownPopoverShow = true;
        createPopper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, {
          placement: 'bottom-start',
        });
      }
    },
    toggleDD(event, redirect = null) {
      event.preventDefault();
      if (redirect) {
        this.toggleDashboardProfile(false);
        this.$router.push({ path: `/${redirect}` });
      } else {
        this.toggleDashboardProfile();
      }
      this.toggleDropdown(event);
    },
    async logout() {
      this.toggleDashboardProfile();
      // eslint-disable-next-line max-len
      const result = await this.removeAuthentication({ accessToken: this.accessToken, tokenType: this.tokenType });
      if (result) {
        this.$router.go();
        window.location.reload();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/UserDropdown.vue